import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search, Building2, LandPlot, Compass } from "lucide-react";

export default function Buy() {
  return (
    <>
      <section className="bg-[#101827] text-white">
        <div className="ae-container pt-28 pb-16">
          <div className="ae-eyebrow mb-3">Buy Property</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-3xl">
            Find the right property, with the right advice.
          </h1>
          <p className="text-white/80 mt-5 max-w-3xl leading-relaxed">
            Browse residential land, flats, independent houses and commercial spaces in Kolkata and
            South 24 Parganas — advisory included.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/properties?intent=buy" className="ae-btn-gold"><Search className="w-4 h-4" /> Browse Properties</Link>
            <Link to="/land-survey" className="ae-btn-outline !border-white/30 !text-white hover:!bg-white hover:!text-[#101827]"><Compass className="w-4 h-4" /> Pre-purchase Survey</Link>
          </div>
        </div>
      </section>

      <section className="ae-section">
        <div className="ae-container grid md:grid-cols-3 gap-6">
          {[
            { icon: LandPlot, title: "Land & Plots", desc: "Residential and agricultural land options with clear boundary data." , to: "/properties?type=residential_land"},
            { icon: Building2, title: "Flats & Apartments", desc: "2 to 4 BHK flats in gated communities and standalone buildings.", to: "/properties?type=flat" },
            { icon: Building2, title: "Commercial Spaces", desc: "Ground-floor retail and office units on main-road frontages.", to: "/properties?type=commercial" },
          ].map((c, i) => (
            <Link to={c.to} key={i} className="ae-card p-6">
              <div className="w-11 h-11 rounded-lg bg-[#183B66] text-white flex items-center justify-center mb-4"><c.icon className="w-5 h-5" /></div>
              <h3 className="font-semibold text-[#101827] text-lg mb-1.5">{c.title}</h3>
              <p className="text-[#64748B] text-sm leading-relaxed">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#183B66]">
                Browse <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
